// extracted by mini-css-extract-plugin
module.exports =  {"link":"_25d45facb5--link--e7z7V","icon":"_25d45facb5--icon--IBQt2","icon--with-title":"_25d45facb5--icon--with-title--uY8sa","title":"_25d45facb5--title--nV4cM"};